var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBrandTorStyleBrand = function SvgBrandTorStyleBrand(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg_icon_BrandTorStyleBrand__clip0_3953_122663)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F2E4FF",
    d: "M12 23.531c6.369 0 11.531-5.162 11.531-11.531S18.37.469 12 .469.469 5.63.469 12 5.63 23.531 12 23.531"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_BrandTorStyleBrand__paint0_linear_3953_122663)",
    d: "M12.025 21.818v-1.455a8.363 8.363 0 0 0 0-16.726V2.182c5.41.014 9.793 4.403 9.793 9.818 0 5.414-4.382 9.804-9.793 9.817m0-5.092a4.727 4.727 0 0 0 0-9.452V5.819a6.181 6.181 0 0 1 0 12.361zm0-7.27a2.545 2.545 0 0 1 0 5.088zM0 12c0 6.627 5.372 12 12 12 6.627 0 12-5.373 12-12 0-6.628-5.373-12-12-12C5.372 0 0 5.372 0 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_BrandTorStyleBrand__paint1_linear_3953_122663)",
    d: "M12 1.36c-5.98 0-10.828 4.826-10.828 10.78 0 5.955 4.848 10.782 10.828 10.782z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_icon_BrandTorStyleBrand__paint0_linear_3953_122663",
    x1: 1200,
    x2: 1200,
    y1: 2400,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#420C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#951AD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_icon_BrandTorStyleBrand__paint1_linear_3953_122663",
    x1: -529.406,
    x2: -529.406,
    y1: 2157.61,
    y2: 1.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#420C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#951AD1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "svg_icon_BrandTorStyleBrand__clip0_3953_122663"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBrandTorStyleBrand);
export { ForwardRef as ReactComponent };